// i18n area 'hci' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.da-DK.meta.json.
import type { enUS } from './hci'

export const daDK: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-clustre',
      createButton: 'Opret Ceph-cluster',
      emptyTitle: 'Ingen håndterede Ceph-clustre',
      emptyBody: 'TVirt udruller og ejer Ceph på medlemsnoderne, hyperkonvergeret med VM-lasten. Opret et cluster: den første monitor og dens manager fødes automatisk på den valgte kontrolnode — udbyg det derefter med flere monitorer og OSD-enheder.',
      pageTitle: 'Ceph-cluster',
      colState: 'Status',
      colMembers: 'Medlemmer',
      colSize: 'Størrelse',
      colVersion: 'Ceph-version',
      sizeCell: '{used} GiB brugt af {total} GiB i alt',
      phase: {
        'not-deployed': 'Ikke deployet',
        deploying: 'Deploy i gang',
        healthy: 'Sundt',
        degraded: 'Degraderet',
        error: 'Fejl',
        destroying: 'Under destruktion',
        destroyed: 'Destrueret'
      },
      health: {
        HEALTH_OK: 'Sundt (HEALTH_OK)',
        HEALTH_WARN: 'Med advarsler (HEALTH_WARN)',
        HEALTH_ERR: 'I fejl (HEALTH_ERR)',
        unknown: 'Endnu ikke observeret',
        observedAt: 'observeret {time}'
      },
      create: {
        title: 'Opret Ceph-cluster',
        info: 'Når et nyt Ceph-cluster oprettes, skal den første node vælges, hvor rollerne MON og MGR installeres. Der skal også angives, hvilken subnet Ceph-trafikken skal køre på: public-subnettet bruges til den generelle netværkstrafik, mens cluster-subnettet bruges til de interne replikaer mellem OSD-enhederne; det behøver ikke nødvendigvis at være forskellige subnets.',
        controlNode: 'Kontrolnode',
        controlNodeHint: 'Medlemsnoden, hvor den første MON + MGR fødes.',
        publicSubnet: 'Public-subnet',
        publicSubnetHint: 'En Subnet registreret i IPAM — Cephs public_network. Uforanderlig efter oprettelsen.',
        clusterSubnet: 'Cluster-subnet',
        clusterSubnetHint: 'En Subnet registreret i IPAM — Cephs cluster_network (replika/backfill).',
        noSubnets: 'Ingen Subnet registreret — opret dem først i IPAM',
        sameSubnet: 'Samme subnet til public- og cluster-trafik',
        sameSubnetHint: 'Afkrydset = cluster-netværket (replika/backfill) falder sammen med public. Ikke afkrydset = vælg dets subnet OG kontrolnodens adresse inde i det.',
        controlAddress: 'Kontrolnodens adresse',
        controlAddressHint: 'En adresse, IPAM kender for noden inde i public-subnettet.',
        controlClusterAddress: 'Kontrolnodens cluster-adresse',
        controlClusterAddressHint: 'En adresse, IPAM kender for noden inde i cluster-subnettet.',
        noAddresses: 'IPAM kender ingen adresser for denne node inde i det valgte subnet',
        started: 'Cluster oprettet — bootstrap fortsætter som macrotask; fasen opdaterer sig selv',
        error: 'Clusteret blev afvist'
      },
      detail: {
        actions: 'Tilgængelige handlinger',
        tabOverview: 'Oversigt',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pools',
        tabObjects: 'Objekter',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avanceret',
        phase: 'Fase',
        checksTitle: 'Aktive helbredscheck',
        noChecks: 'Ingen aktive helbredscheck',
        checkMuted: 'stumt',
        summaryPools: 'Pools',
        summaryFilesystems: 'Filsystemer',
        nodesCard: 'Noder',
        monHint: 'En MGR kører colocated med hver MON. Tre MON er det anbefalede quorum; et laboratoriecluster starter med én. OSD og MDS bor i deres egne faner.',
        monHintSplit: 'MON og MGR er adskilt på dette cluster (Avanceret): hver rolle er sit eget medlemskab pr. node. Tre MON er det anbefalede quorum; mindst én MGR skal findes.',
        noMons: 'Ingen monitor erklæret',
        addNode: 'Tilføj node',
        removeNode: 'Fjern node',
        removeNodeFrom: 'Fjern noden {node} (dens MON og den colocatede MGR)',
        roleMon: 'MON-rolle',
        roleMgr: 'MGR-rolle',
        roleNa: 'N/A',
        roleNotObserved: 'endnu ikke observeret',
        monInQuorum: 'i quorum',
        monOutQuorum: 'uden for quorum',
        mgrActive: 'aktiv',
        mgrStandby: 'standby',
        addRoleMon: 'Tilføj MON-rolle',
        removeRoleMon: 'Fjern MON-rolle',
        addRoleMgr: 'Tilføj MGR-rolle',
        removeRoleMgr: 'Fjern MGR-rolle',
        restartMon: 'Genstart MON-tjeneste',
        restartMgr: 'Genstart MGR-tjeneste',
        addMon: 'Tilføj MON',
        removeMon: 'Fjern MON',
        removeMonFrom: 'Fjern MON-rollen fra {node}',
        addMgr: 'Tilføj MGR',
        removeMgr: 'Fjern MGR',
        removeMgrFrom: 'Fjern MGR-rollen fra {node}',
        addMds: 'Tilføj MDS',
        removeMds: 'Fjern MDS',
        removeMdsFrom: 'Fjern MDS-rollen fra {node}',
        mdsSection: 'Metadata-servere (MDS)',
        noMds: 'Ingen MDS erklæret — et filsystem kræver først en',
        mdsHint: 'MDS-medlemskabet er sit eget fra dag ét: et cluster uden CephFS erklærer ingen, én aktiv plus én standby betjener et filsystem fint. Ceph vælger aktive og standby blandt de erklærede daemons.',
        mdsActiveFor: 'aktiv — {fs}',
        mdsNotObserved: 'endnu ikke observeret',
        lastMdsGuard: 'Den sidste MDS kan ikke fjernes, så længe et filsystem findes — fjern først filsystemerne',
        lastMonGuard: 'Den sidste MON kan ikke fjernes — at destruere clusteret er den eneste udvej',
        lastMgrGuard: 'Den sidste MGR kan ikke fjernes — et håndteret cluster kører aldrig uden manager',
        registerDevice: 'Tilføj OSD',
        unregisterDevice: 'Afregistrer',
        activeDeviceGuard: 'Aktiv OSD — den forlader clusteret gennem OSD-livscyklussen, ikke fra registret',
        colNode: 'Node',
        devicePhase: { registered: 'Registreret', active: 'Aktiv' },
        health: 'Helbred',
        state: 'Status',
        fsid: 'fsid',
        fsidPending: 'mangler — prøv bootstrap igen',
        version: 'Ceph-version',
        publicNetwork: 'Public-netværk',
        clusterNetwork: 'Cluster-netværk',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ingen handling tilgængelig i denne fase',
        destroyedNote: 'Cluster destrueret — rækken fjernes automatisk om lidt'
      },
      overview: {
        services: 'Tjenester',
        ok: 'sunde',
        warning: 'warning',
        down: 'nede',
        pgTitle: 'PG-tilstande',
        pgTotal: '{n} PG i alt',
        capacityTitle: 'Plads',
        ioTitle: 'Aktuel I/O',
        ioReadBw: 'Læse-båndbredde',
        ioWriteBw: 'Skrive-båndbredde',
        ioReadIops: 'Læse-IOPS',
        ioWriteIops: 'Skrive-IOPS',
        notObserved: 'endnu ikke observeret'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Status',
        colSize: 'Størrelse',
        colPgs: 'PG',
        empty: 'Ingen OSD — tilføj en fra en erklæret datadisk',
        markIn: 'Marker IN',
        markOut: 'Marker OUT',
        scrub: 'Udfør scrub',
        deepScrub: 'Udfør dyb scrub',
        restart: 'Genstart tjeneste',
        details: 'Detaljer',
        actionGuard: 'Kun på en aktiv OSD i et deployet cluster',
        inTitle: 'Marker OSD IN',
        inBody: 'osd.{id} vender tilbage til datadistributionen (ceph osd in): Ceph rebalancerer data over på den.',
        outTitle: 'Marker OSD OUT',
        outBody: 'osd.{id} forlader datadistributionen (ceph osd out): dens data rebalanceres andetsteds, og redundansen er REDUCERET, mens backfill kører. Reversibelt når som helst med Marker IN.',
        scrubTitle: 'Planlæg scrub',
        scrubBody: 'Der planlægges en scrub af osd.{id}: mon sætter den i kø, og PG-tilstandene fra de efterfølgende sweeps fortæller udfaldet.',
        deepScrubTitle: 'Planlæg dyb scrub',
        deepScrubBody: 'Der planlægges en dyb scrub af osd.{id}: varianten, der verificerer hver byte — tungere på I/O, samme mekanik.',
        restartTitle: 'Genstart OSD-tjeneste',
        restartBody: 'osd.{id} stoppes og genstartes gennem workerens supervision på dens node.',
        started: 'Handling startet — observationen opdaterer sig selv',
        error: 'OSD-handlingen blev afvist'
      },
      osdDetail: {
        title: 'OSD-detaljer',
        tabGeneral: 'Generelt',
        tabNetwork: 'Netværk',
        tabDevices: 'Enheder',
        version: 'Version',
        hostname: 'Hostname',
        dataPath: 'OSD-datasti',
        objectStore: 'OSD object store',
        encrypted: 'Krypteret',
        yes: 'Ja',
        no: 'Nej',
        memory: 'Hukommelsesforbrug (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-adresse (klienter & monitorer)',
        hbFront: 'Heartbeat-adresse front',
        back: 'Back-adresse (OSD)',
        hbBack: 'Heartbeat-adresse back',
        colDevice: 'Device',
        colType: 'Type',
        colPhysical: 'Fysisk device',
        colSize: 'Størrelse',
        volumeTitle: 'Volume-detaljer',
        creationTime: 'Oprettelsesdato',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Intet device observeret for denne OSD'
      },
      restart: {
        title: 'Genstart tjeneste',
        monBody: 'MON-daemonen på {node} stoppes og genstartes gennem workerens supervision.',
        mgrBody: 'MGR-daemonen på {node} stoppes og genstartes gennem workerens supervision.',
        started: 'Genstart startet — observationen opdaterer sig selv',
        error: 'Genstarten blev afvist'
      },
      encryptionMode: {
        alwaysOn: 'Altid aktiveret (dmcrypt)',
        alwaysOff: 'Altid deaktiveret',
        perOsd: 'Valg pr. OSD',
        section: 'OSD-kryptering at rest',
        title: 'Skift OSD-krypteringstilstand',
        hint: 'Hvordan NYE OSD-enheder klargøres. Eksisterende OSD-enheder beholder deres tilstand pr. disk: for at ændre den fjernes og genskabes den enkelte OSD.',
        body: 'Tilstanden bliver "{mode}" og gælder KUN for NYE OSD-enheder: hver eksisterende OSD beholder sin nuværende krypteringstilstand.',
        apply: 'Skift tilstand',
        error: 'Tilstandsskiftet blev afvist'
      },
      pin: {
        address: 'Public-adresse (valgfrit pin)',
        clusterAddress: 'Cluster-adresse (valgfrit pin)',
        autoPlaceholder: 'automatisk i subnettet {cidr}',
        hint: 'Adressering pr. daemon: tomt = Ceph kobler sig selv på inde i det erklærede netværk; udfyldt = denne instans pinnes til adressen i sin conf-sektion.'
      },
      addMon: {
        title: 'Tilføj node',
        node: 'Node',
        address: 'Public-adresse',
        addressHint: 'Nodens adresser, som IPAM kender inde i public-subnettet — automatisk, når en eksisterende erklæring dækker noden.',
        clusterAddress: 'Cluster-adresse',
        clusterAddressHint: 'Obligatorisk: cluster-subnettet er adskilt, og noden er endnu ikke erklæret i det.',
        noAddresses: 'IPAM kender ingen adresser for denne node inde i subnettet',
        error: 'Tilføjelsen af mon blev afvist'
      },
      removeMon: {
        title: 'Fjern MON',
        body: 'MON og dens colocatede MGR forlader noden {node}. På et deployet cluster stoppes daemonerne og fjernes fra quorum.',
        error: 'Fjernelsen af MON blev afvist'
      },
      addMgr: {
        title: 'Tilføj MGR',
        node: 'Node',
        hint: 'Avanceret (MON/MGR adskilt): en standalone manager fødes på den valgte medlemsnode med en node-affin task. Cephs active/standby-valg udpeger selv den aktive MGR.',
        error: 'Tilføjelsen af MGR blev afvist'
      },
      removeMgr: {
        title: 'Fjern MGR',
        body: 'Den standalone MGR forlader noden {node}. På et deployet cluster stoppes daemonen, og dens tilstand fjernes; nodens MON (hvis den findes) røres ikke.',
        error: 'Fjernelsen af MGR blev afvist'
      },
      addMds: {
        title: 'Tilføj MDS',
        node: 'Node',
        hint: 'CephFS-metadata-serveren: den fødes på den valgte medlemsnode med en node-affin task, superviseret af workeren ligesom MON og MGR. Ceph vælger selv aktive og standby — én aktiv plus én standby betjener et filsystem fint.',
        error: 'Tilføjelsen af MDS blev afvist'
      },
      removeMds: {
        title: 'Fjern MDS',
        body: 'MDS forlader noden {node}. På et deployet cluster stoppes daemonen, og dens tilstand fjernes; API afviser den sidste MDS, så længe et filsystem har brug for den.',
        error: 'Fjernelsen af MDS blev afvist'
      },
      split: {
        title: 'MON/MGR adskilt',
        label: 'Tillad MON og MGR på adskilte noder',
        hint: 'Fra (default) = den ratificerede standard: en MGR kører colocated med hver MON, ét enkelt medlemskab. Til = MGR-medlemskabet bliver sit eget, håndteret med handlingerne Tilføj/Fjern MGR i fanen Managementnoder.',
        enable: 'Aktiver',
        disable: 'Deaktiver',
        enableBody: 'MGR-medlemskabet bliver uafhængigt af MON, initialiseret fra den nuværende colocation. Handlingerne Tilføj/Fjern MGR armeres i fanen Managementnoder. Dette slækker platformens default — behold det kun, hvis du ved, hvorfor du har brug for det.',
        disableBody: 'Tilbage til standard-colocationen: en MGR med hver MON, ét enkelt medlemskab. Kun lovligt, hvis MGR-medlemskabet allerede falder sammen med MON — bring det på linje først med Tilføj/Fjern MGR, ellers afviser API.',
        error: 'Ændringen blev afvist'
      },
      rawEditor: {
        title: 'Rå CRUSH-editor',
        label: 'Vis den rå crushmap-editor i fanen CRUSH',
        hint: 'Fra (default) = den guidede regelflade er standardværktøjet. Til = fanen CRUSH viser også den dekompilerede crushmap som redigerbar tekst. At gemme kræver altid sudo og clusterets navn som bekræftelse og går gennem crushtools compile + test, FØR den når clusteret.'
      },
      osdFlags: {
        section: 'Globale OSD-flag',
        title: 'OSD-flag-override',
        notObserved: 'endnu ikke observeret',
        standardFlowsHint: 'Platformens standardflows håndterer selv disse flag i de normale tilfælde (vedligeholdelse af en node sætter et målrettet noout, diskudskiftning går gennem OSD-livscyklussen). Denne sektion er den manuelle override for operatøren, der ved, hvad han gør.',
        notDeployedGuard: 'OSD-flag findes kun på et deployet cluster',
        set: 'Sæt flag',
        unset: 'Fjern flag',
        setBody: 'Det globale flag {flag} bliver SAT på osdmappen. Det består, indtil det fjernes eksplicit — et glemt flag degraderer clusterets selvhelbredelse.',
        unsetBody: 'Det globale flag {flag} bliver FJERNET fra osdmappen.',
        error: 'Flagændringen blev afvist',
        flag: {
          noout: 'Ingen OSD markeres out af datadistributionen — ingen rebalancering, når en daemon går tabt',
          norebalance: 'Rebalanceringen af data er suspenderet',
          nobackfill: 'Backfill er suspenderet',
          norecover: 'Recovery er suspenderet',
          pause: 'AL klient-I/O er på pause (læsninger og skrivninger)',
          noin: 'OSD-enheder, der starter, markeres ikke automatisk in',
          nodown: 'OSD-enheder, der ikke kan nås, markeres ikke down — det maskerer reelle fejl'
        }
      },
      pools: {
        section: 'Pools',
        create: 'Opret pool',
        createGuard: 'Pools findes kun på et deployet cluster',
        notObserved: 'Ingen observation af pools — mon-sweepet rapporterer her',
        empty: 'Ingen pools på clusteret',
        colName: 'Navn',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Application',
        colRule: 'CRUSH-regel',
        colUsage: 'Forbrug',
        observedAtLabel: 'Observeret',
        objects: '{n} objekter',
        inUseBy: 'i brug af {name}',
        internalGuard: 'Intern Ceph-pool — platformen sletter den aldrig',
        delete: 'Slet pool',
        deleteGuard: 'Konsumeret af storagen {name} — slet storagen først',
        hint: 'Kun replikerede pools (erasure coding uden for scope i v1). Replikaerne bor i Ceph: denne tabel er sandheden observeret af mon-sweepet.',
        createTitle: 'Opret pool',
        createHint: 'Poolen fødes på clusteret med den ønskede replikering og application rbd aktiveret — arbejdet gøres af en task på en MON-node. Slå "Foreslå som storage" til for at konsumere den med det samme i samme greb.',
        name: 'Poolens navn',
        nameHint: 'DNS-safe (små bogstaver, cifre, bindestreger).',
        size: 'Replikaer (size)',
        sizeHint: 'Kopier af hvert objekt. Default 3.',
        minSize: 'Minimum replikaer (min_size)',
        minSizeHint: 'Færreste kopier for at betjene I/O — følger size − 1, indtil du ændrer det.',
        createError: 'Oprettelsen af poolen blev afvist',
        deleteTitle: 'Slet pool',
        deleteBody: 'Poolen {pool} og HVERT objekt i den destrueres irreversibelt. Skriv poolens navn for at bekræfte.',
        confirmLabel: 'Poolens navn',
        confirmHint: 'Skriv poolens navn for at bekræfte',
        deleteError: 'Sletningen af poolen blev afvist',
        detailTitle: 'Pool-detaljer',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktiv',
        autoscalerOff: 'Ikke aktiv',
        autoscalerWarn: 'Notifikation',
        pgNumLabel: 'Antal PG',
        pgNumCaption: 'Observeret: autoscaleren kan ændre det på egen hånd — dette felt skriver et ønske.',
        storage: 'Tilknyttet TVirt-storage',
        addAsStorage: 'Tilføj som TVirt-storage',
        ruleSudoHint: 'Skift af CRUSH-regel kræver operatøradgangskoden.',
        updateError: 'Ændringen af poolen blev afvist',
        updated: 'Ændring af poolen startet — observationen opdaterer sig selv'
      },
      crush: {
        section: 'CRUSH-regler',
        notObserved: 'Ingen CRUSH-observation endnu — mon-sweepet rapporterer her',
        empty: 'Ingen regler observeret på clusteret',
        hint: 'En regel afgør, HVOR kopierne af hvert objekt lander — dens fejldomæne er den enhed, der kan fejle uden datatab. Pools peger på en regel; den indbyggede replicated_rule (én replika pr. server) er default fra fødslen.',
        create: 'Opret regel',
        createGuard: 'CRUSH-regler findes kun på et deployet cluster',
        createTitle: 'Opret CRUSH-regel',
        createHint: 'En regel = et valg af fejldomæne. Reglen fødes replikeret på default-rooten — arbejdet gøres af en task på en MON-node; tilknyt pools fra fanen Pools bagefter.',
        createError: 'Oprettelsen af reglen blev afvist',
        name: 'Reglens navn',
        nameHint: 'DNS-safe (små bogstaver, cifre, bindestreger).',
        domain: 'Fejldomæne',
        domainChoice: {
          osd: 'Hver replika på en forskellig OSD',
          host: 'Hver replika på en forskellig server',
          rack: 'Hver replika i et forskelligt rack'
        },
        domainCustom: 'Tilpasset (håndskrevne steps)',
        domainOther: 'Hver replika i en forskellig {type}',
        rackGuardHint: 'Intet rack-bucket findes i den observerede hierarki: reglen kan oprettes alligevel, men ingen pool kan pege på den, før et rack er erklæret i medlemsservernes placering (nodens indstillinger) — genopretningstasken bygger bucketet, og tilknytningen åbner sig selv.',
        treeTitle: 'Observeret hierarki',
        treeNotObserved: 'Ingen observation af hierarkiet — mon-sweepet rapporterer her',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH-mappen, som clusteret ser den: root → erklærede niveauer → servere (host) → OSD. Topologien følger hver servers erklærede placering (nodens indstillinger) — et positionsskift genoprettes via task.',
        unplacedWarning: 'Medlemmer uden erklæret position: {nodes} — deres hosts bliver stående direkte under rooten, uden for den erklærede topologi. Erklær positionen i nodens indstillinger (en advarsel, aldrig en blokering).',
        colName: 'Navn',
        colDomain: 'Fejldomæne',
        colPools: 'Pools',
        builtinChip: 'builtin',
        builtinGuard: 'Clusterets default-regel — platformen sletter den aldrig',
        detailAction: 'Regeldetaljer',
        detailType: 'Type',
        backToRules: 'Regler',
        ruleNotObserved: 'Den observerede regelliste nævner ikke denne regel',
        noPools: 'Ingen pool rider på denne regel',
        delete: 'Slet regel',
        deleteTitle: 'Slet CRUSH-regel',
        deleteBody: 'Reglen {rule} fjernes fra clusterets crushmap. Ingen pool må ride på den. Skriv reglens navn for at bekræfte.',
        deleteGuard: 'Redet af poolen {name} — peg poolen om først',
        confirmLabel: 'Reglens navn',
        confirmHint: 'Skriv reglens navn for at bekræfte',
        deleteError: 'Sletningen af reglen blev afvist',
        changeRule: 'Skift CRUSH-regel',
        changeRuleTitle: 'Skift CRUSH-regel',
        changeRuleHint: 'Poolen begynder at placere sine objekter efter den valgte regel — Ceph flytter de eksisterende data for at rette ind (på en fuld pool følger en rebalancering).',
        changeRuleError: 'Regelskiftet blev afvist',
        rule: 'CRUSH-regel',
        rawTitle: 'Rå crushmap (dekompileret)',
        rawWarning: 'FARE: denne tekst er HELE clusterets placeringspolitik. En forkert map kan ødelægge placementet for alle pools på én gang. At gemme kompilerer og tester mappen med crushtool, FØR den injiceres — men en gyldig map kan stadig være en dårlig idé.',
        rawReload: 'Genindlæs',
        rawLoading: 'Query i luften — en read-only task dekompilerer crushmappen…',
        rawSave: 'Gem crushmap',
        rawSaveTitle: 'Injicer crushmap',
        rawSaveBody: 'Den redigerede tekst erstatter crushmappen for HELE clusteret efter crushtools compile + test. Skriv clusterets navn for at bekræfte.',
        rawConfirmLabel: 'Clusterets navn',
        rawConfirmHint: 'Skriv {name} for at bekræfte',
        rawError: 'Operationen på crushmappen fejlede',
        rawHint: 'Teksten er crushtool -d-formen. Compile- og testfejl kommer tilbage ord for ord fra crushtool — mappen når ikke clusteret, hvis en af de to porte fejler.'
      },
      objects: {
        poolsSection: 'Objektudforsker',
        poolsHint: 'Vælg en pool for at liste dens RBD-images. Hver dyb læsning kører som read-only task på en MON-node — den blokerer ikke (og blokeres ikke af) de rigtige operationer.',
        deployedGuard: 'Objekt-queries svarer kun på et deployet cluster',
        browse: 'Gennemse objekterne',
        detailAction: 'Image-detaljer',
        backToPools: 'Pools',
        backToImages: 'Images',
        refresh: 'Opdater',
        loading: 'Query i luften — en read-only task spørger clusteret…',
        error: 'Queryen fejlede',
        retry: 'Prøv igen',
        notRbd: 'Pool med application "{app}" — den indeholder ingen RBD-images, intet at udforske her',
        noImages: 'Ingen RBD-images i denne pool',
        colImage: 'Image',
        colSize: 'Størrelse',
        colObjects: 'Objekter',
        colSnapshots: 'Snapshots',
        imagesHint: 'Diskene på en konsumerende rbd-storage er images med deres disk-id som navn. Objekttallet er det provisionerede (størrelse / objektstørrelse) — det reelle forbrug bor i image-detaljerne.',
        infoTitle: 'Image',
        infoSize: 'Virtuel størrelse',
        infoObjects: 'Objekter (provisioneret)',
        infoObjectSize: 'Objektstørrelse',
        infoPrefix: 'Objektpræfiks',
        infoFormat: 'Format',
        infoFeatures: 'Features',
        usageTitle: 'Reelt forbrug (rbd du)',
        usageOf: 'af {provisioned} GiB provisioneret',
        usageHint: 'Thin af natur: kun de skrevne objekter optager bytes.',
        watchersTitle: 'Watchers',
        noWatchers: 'Ingen watchers — ingen har dette image åbent lige nu',
        snapshotsTitle: 'RBD-snapshots',
        noSnapshots: 'Ingen RBD-snapshots på dette image',
        colSnapshot: 'Snapshot',
        colProtected: 'Beskyttet',
        colTimestamp: 'Oprettet',
        protected: 'beskyttet',
        mappingTitle: 'Fysisk mapning (OSD-sæt)',
        mappingSampled: 'Stikprøve på {sampled} objekter af {total} — ærligt resume: for store images konvergerer sættet mod ALLE poolens OSD-enheder (CRUSH spreder objekterne over hele poolen).',
        mappingComplete: 'Alle objekter mappet ({total} af {total}).',
        objectQueryTitle: 'Map et enkelt objekt',
        objectName: 'Objektnavn',
        objectHint: 'RADOS-objektnavne er <præfiks>.<16-hex-indeks> — ceph osd map svarer med PG og OSD-tripler.',
        mapObject: 'Map',
        primary: 'primær: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrer OSD-enhed',
        hint: 'På et levende cluster KLARGØR registreringen også enheden: den bliver en BlueStore-OSD med en automatisk node-affin task (aldrig tom, ratificeret 2026-07-24). En enhed tilhører højst ét Ceph-cluster i hele flåden.',
        disk: 'Datadisk',
        diskHint: 'Nodens erklærede datadiske — navn og serienummer',
        noDeclared: 'Ingen datadisk erklæret på denne node — marker dem først i nodens lokale indstillinger',
        serialHint: 'Enhedens serienummer — identitetens pin',
        encrypted: 'Krypter denne OSD (dmcrypt)',
        encryptedHint: 'Valget pr. OSD (clusterets tilstand er "valg pr. OSD"): det fryses på denne disk ved registreringen — et senere tilstandsskift omskriver det aldrig; det gør rækkehandlingen krypter/dekrypter.',
        error: 'Registreringen blev afvist'
      },
      unregisterDevice: {
        title: 'Afregistrer enhed',
        body: 'Kun registret: {name} ophører med at være OSD-kandidat for dette cluster. Dens bytes røres ikke.',
        error: 'Afregistreringen blev afvist'
      },
      deploy: {
        action: 'Prøv deploy igen',
        title: 'Prøv bootstrap igen',
        body: 'Fødsels-bootstrappen starter forfra fra den nuværende konfiguration: mon-daemonerne starter, hver registreret enhed klargøres og aktiveres som BlueStore-OSD. Operationen kører som macrotask — fasen opdaterer sig selv.',
        started: 'Bootstrap startet — fortsætter som macrotask; fasen opdaterer sig selv',
        error: 'Bootstrappen blev afvist'
      },
      propose: {
        action: 'Foreslå som storage',
        title: 'Foreslå som storage',
        hintPool: 'Den eksisterende pool {name} bliver en TVirt-storage: en cephx-identitet begrænset til poolen havner i keystoret, og ceph-rbd-storagen fødes klar. Forslaget konsumerer poolen — det opretter aldrig en.',
        hintFs: 'Det eksisterende filsystem {name} bliver en TVirt-storage: en cephx-identitet begrænset til filsystemet havner i keystoret, og cephfs-storagen fødes klar og monteret. Forslaget konsumerer filsystemet — det opretter aldrig et.',
        name: 'Storagens navn',
        nameHint: 'DNS-1123, unikt i scopet — cephx-identiteten opkaldes efter den.',
        path: 'Sti inde i filsystemet',
        pathHint: 'Absolut sti inde i filsystemet, som storagen monterer — / hvis du er i tvivl.',
        alsoPropose: 'Foreslå som storage med det samme',
        alsoProposePoolHint: 'Efter oprettelsen foreslår samme greb den nyfødte pool som ceph-rbd-storage — to eksplicitte kald, én enkelt dialog.',
        alsoProposeFsHint: 'Efter oprettelsen foreslår samme greb det nyfødte filsystem som cephfs-storage — to eksplicitte kald, én enkelt dialog.',
        guard: 'Foreslå som storage — kun på et healthy cluster',
        started: 'Forslaget accepteret — storagen materialiserer sig; du finder den under Storage',
        submit: 'Opret storage',
        error: 'Forslaget blev afvist'
      },
      fs: {
        section: 'Filsystemer',
        create: 'Opret filsystem',
        createGuard: 'Filsystemer findes kun på et deployet cluster',
        mdsFirstGuard: 'Tilføj først en MDS — et filsystem uden metadata-server fødes ubrugeligt',
        notObserved: 'Ingen observation af filsystemerne — MON-sweepet rapporterer her',
        empty: 'Ingen filsystemer på clusteret',
        colName: 'Navn',
        colPools: 'Pools',
        colMds: 'MDS',
        noActiveMds: 'ingen aktiv MDS',
        delete: 'Fjern filsystem',
        deleteGuard: 'Konsumeret af storagen {name} — slet storagen først',
        hint: 'Et filsystem ejer sine data- og metadata-pools (cephfs.<navn>.data / .meta): de fødes med det og dør med det — removeFs, aldrig en manuel pool-sletning. Denne tabel er sandheden observeret af MON-sweepet.',
        createTitle: 'Opret filsystem',
        createHint: 'Filsystemet fødes på clusteret med sine to pools (application cephfs) og betjenes af de erklærede MDS-daemons — arbejdet gøres af en task på en MON-node. Slå "Foreslå som storage" til for at konsumere det med det samme i samme greb.',
        name: 'Filsystemets navn',
        nameHint: 'DNS-safe (små bogstaver, cifre, bindestreger).',
        sizeHint: 'Replikaer for BEGGE de nyfødte pools. Default 3.',
        createError: 'Oprettelsen af filsystemet blev afvist',
        deleteTitle: 'Fjern filsystem',
        deleteBody: 'Filsystemet {fs} og HVER fil i det destrueres irreversibelt — dets data- og metadata-pools dør med det. Skriv filsystemets navn for at bekræfte.',
        confirmLabel: 'Filsystemets navn',
        confirmHint: 'Skriv filsystemets navn for at bekræfte',
        deleteError: 'Fjernelsen af filsystemet blev afvist'
      },
      destroy: {
        action: 'Destruer',
        retryAction: 'Prøv sletningen igen',
        retryGuard: 'Destruktionen kører — retry gælder en fejlet destruktion (ellers afviser leasen)',
        title: 'Destruer clusteret',
        body: 'Den deployede fabric demonteres: hver daemon i dette cluster stopper, dens systemtilstand og nøglerne i keystoret frigives. Når destruktionen lykkes, fjernes clusteret automatisk.',
        confirmLabel: 'Clusterets navn',
        confirmHint: 'Skriv clusterets navn for at bekræfte',
        wipe: 'Wipe de registrerede enheder',
        wipeHint: 'Afkrydset: signaturerne på hver registreret enhed slettes — dataene ovenpå er destrueret. Ikke afkrydset: dens bytes forbliver intakte, og enhederne vender tilbage som registrerede.',
        guard: 'Destruer — intet deployet',
        started: 'Destruktion startet — fortsætter som macrotask; fasen opdaterer sig selv',
        error: 'Destruktionen blev afvist'
      },
      delete: {
        guard: 'Slet — kun en ikke-deployet konfiguration (destruer først)',
        title: 'Slette {name}?',
        body: 'Konfigurationen og dens enhedsregister fjernes. Kun lovligt, så længe intet er deployet.',
        error: 'Sletningen blev afvist'
      }
    }
  }
}
